import { render, staticRenderFns } from "./PanelWidgetOptions.vue?vue&type=template&id=44fb17be&"
import script from "./PanelWidgetOptions.vue?vue&type=script&lang=js&"
export * from "./PanelWidgetOptions.vue?vue&type=script&lang=js&"
import style0 from "./PanelWidgetOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports